/** Public origin of the portal; the widget and its API live under it. */
export const PORTAL_ORIGIN = (import.meta.env.VITE_PUBLIC_URL ?? "https://portal.codemonk.io").replace(/\/$/, "");

/**
 * The `<script>` tag clients paste into a prototype (contract shared with src/widget).
 *
 * Builds may also add the optional `data-batch`, `data-version` and `data-version-label`
 * attributes (the template's FeedbackWidget does) so each item is tagged with the prototype
 * version it was about; the snippet shown to clients leaves them out.
 */
export function widgetSnippet(token: string, origin: string = PORTAL_ORIGIN): string {
  return [
    `<script src="${origin}/widget/feedback-widget.js"`,
    `        data-project-token="${token}"`,
    `        data-api-base="${origin}/api"`,
    `        defer></script>`,
  ].join("\n");
}
